import React from "react";

export default function VideoGrid({
  onOvertlyClick,
  onAggregateClick,
  onConscienceClick,
  onMapClick,
}) {
  const videos = [
    { src: "/videos/video1.mp4", onClick: onOvertlyClick },
    { src: "/videos/video2.mp4", onClick: onAggregateClick },
    { src: "/videos/video3.mp4", onClick: onMapClick },
    { src: "/videos/video4.mp4", onClick: onConscienceClick },
  ];

  return (
    <main className="grid grid-cols-4 gap-4 pl-4 pr-4">
      {videos.map((video, i) => (
        <div
          key={i}
          className="overflow-hidden border-black rounded-smOFF"
          onClick={video.onClick}
        >
          <video
            src={video.src}
            autoPlay
            muted
            loop
            className="w-full h-full object-cover cursor-pointer"
          />
        </div>
      ))}
    </main>
  );
}
